import { getEmployees } from "../../../api/employees";

export const LEAVES_FIELDS = [
  {
    key: "employeeId",
    label: "Employee",
    type: "select",
    apiResKey: "employees",
    api: getEmployees,
  },
];

export const LEAVES_REQUIRED_FIELDS = [
  {
    key: "type",
    label: "type",
    type: "fixed-select",
    options: [{ label: "Sickness", value: "Sickness" }],
  },
  { key: "from", label: "from", type: "date" },
  { key: "to", label: "to", type: "date" },
];

export const FIELDS = [...LEAVES_FIELDS, ...LEAVES_REQUIRED_FIELDS];

export const EDIT_STATUS_FIELDS = [
  {
    key: "status",
    label: "Select Status",
    type: "fixed-select",
    width: 12,
    options: [
      { label: "Approved", value: "Approved" },
      { label: "Rejected", value: "Rejected" },
      { label: "Pending", value: "Pending" },
    ],
  },
];
